import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Plus } from "lucide-react";
import { Button } from "./AdminSharedComponents";

const PageFormHeader = ({
  title,
  backLink,
  backText = "Back",
  onBack, // Optional custom back handler
  onSubmit,
  submitText = "Submit",
  submitIcon = Plus,
  loading = false,
  loadingText = "Processing...",
  cancelLink,
  cancelText = "Cancel",
  onCancel, // Optional custom cancel handler
  formId,
  showBackButton = true,
  className = "",
  children,
  disabled = false, // Optional disabled state for buttons
}) => {
  return (
    <>
      {/* Desktop Header - Sticky */}
      <div
        className={`hidden md:block sticky top-16 md:top-0 z-20 bg-white border-b border-gray-200 shadow-sm ${className}`}
      >
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              {showBackButton &&
                backLink &&
                (onBack ? (
                  <button
                    onClick={onBack}
                    className="flex items-center gap-2 text-base text-primary hover:text-primary-dark transition-colors mr-6"
                  >
                    <ArrowLeft className="h-5 w-5" />
                    {backText}
                  </button>
                ) : (
                  <Link
                    to={backLink}
                    className="flex items-center gap-2 text-base text-primary hover:text-primary-dark transition-colors mr-6"
                  >
                    <ArrowLeft className="h-5 w-5" />
                    {backText}
                  </Link>
                ))}
              <h1 className="text-2xl font-bold text-primary-dark">{title}</h1>
            </div>

            {/* Desktop Action Buttons */}
            <div className="flex items-center gap-3">
              {(cancelLink || onCancel) &&
                (onCancel ? (
                  <Button
                    variant="secondary"
                    onClick={onCancel}
                    disabled={disabled || loading}
                  >
                    {cancelText}
                  </Button>
                ) : (
                  <Link to={cancelLink}>
                    <Button variant="secondary">{cancelText}</Button>
                  </Link>
                ))}
              <Button
                type="submit"
                form={formId}
                loading={loading}
                icon={submitIcon}
                onClick={onSubmit}
                disabled={disabled}
              >
                {loading ? loadingText : submitText}
              </Button>
            </div>
          </div>

          {/* Additional content for desktop */}
          {children && <div className="mt-4">{children}</div>}
        </div>
      </div>

      {/* Mobile Header - Sticky with better spacing */}
      <div className="md:hidden sticky top-[72px] z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="flex justify-between items-center p-4">
          {showBackButton &&
            backLink &&
            (onBack ? (
              <button
                onClick={onBack}
                className="flex items-center gap-2 text-base text-primary hover:text-primary-dark transition-colors"
              >
                <ArrowLeft className="h-5 w-5" />
                <span className="leading-none">{backText}</span>
              </button>
            ) : (
              <Link
                to={backLink}
                className="flex items-center gap-2 text-base text-primary hover:text-primary-dark transition-colors"
              >
                <ArrowLeft className="h-5 w-5" />
                <span className="leading-none">{backText}</span>
              </Link>
            ))}

          <h1 className="text-xl font-bold text-primary-dark">{title}</h1>

          {/* Additional content for mobile */}
          {children && <div className="ml-2">{children}</div>}
        </div>
      </div>

      {/* Mobile Floating Action Buttons */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-gray-200 shadow-lg">
        <div className="px-4 py-3">
          {(() => {
            // Kumpulkan semua action button
            const actions = [];

            if (cancelLink || onCancel) {
              actions.push(
                onCancel ? (
                  <Button
                    key="cancel"
                    variant="secondary"
                    className="w-full"
                    onClick={onCancel}
                    disabled={disabled || loading}
                  >
                    {cancelText}
                  </Button>
                ) : (
                  <Link to={cancelLink} key="cancel">
                    <Button variant="secondary" className="w-full">
                      {cancelText}
                    </Button>
                  </Link>
                )
              );
            }

            actions.push(
              <Button
                key="submit"
                type="submit"
                form={formId}
                loading={loading}
                icon={submitIcon}
                onClick={onSubmit}
                className="w-full"
                disabled={disabled}
              >
                {loading ? loadingText : submitText}
              </Button>
            );

            // Bisa extend: kalau ada `extraActions` dari props, concat di sini

            // Hitung jumlah kolom sesuai jumlah tombol
            const cols = actions.length;

            return (
              <div className={`grid gap-3 grid-cols-${cols}`}>
                {actions.map((btn) => btn)}
              </div>
            );
          })()}
        </div>
      </div>

      {/* Mobile bottom padding to prevent content overlap with floating buttons */}
      {/* <div className="md:hidden h-20" /> */}
    </>
  );
};

export default PageFormHeader;
